import React, { useState } from "react";
import { Button, message } from "antd";
import { controller } from "../controller";
import PortalCredentialsPanel from "../../components/Office/PortalCredentials/PortalCredentialsPanel";

// Committed static guide in public/ (exported from the FTC Training folder).
const GUIDE_URL = "/Smilepass-Insurance-Portal-Setup-Guide.pdf";

// Onboarding "portal credentials" step. Reuses the EXACT My Office
// PortalCredentialsPanel (embedded — no dashboard chrome) so onboarding collects
// portal logins identically to the proven settings page: per-provider accounts,
// 2FA method + destination, and default-account handling all included. The panel
// saves each account itself; this wrapper only owns the wizard-advance
// (Continue / Set up later -> complete-portal-credentials-step).
const PortalCredentials = (props) => {
  const [loading, setLoading] = useState(false);
  const officeId = localStorage.getItem("selectedOffice");

  const advance = async () => {
    if (loading) return;
    setLoading(true);
    const res = await controller.completePortalCredentialsStep();
    setLoading(false);
    if (res && res.status < 250) props.readOnboardingStatus();
    else message.error("Could not continue. Please try again.");
  };

  return (
    <div style={{ maxWidth: 1040 }}>
      <div style={{ marginBottom: 12 }}>
        <a
          href={GUIDE_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#6B43B5", fontWeight: 600, textDecoration: "underline" }}
        >
          Download the portal credentials guide (PDF)
        </a>
      </div>

      <PortalCredentialsPanel embedded officeId={officeId} />

      <Button
        onClick={advance}
        loading={loading}
        className="login-button"
        style={{ marginTop: 16, marginBottom: 12 }}
      >
        Continue
      </Button>
      <div className="skip-btn mt5" style={{ cursor: "pointer" }} onClick={advance}>
        Set up later
      </div>
    </div>
  );
};

export default PortalCredentials;
